import React from 'react';

import CreditLineRequests from './tabs/CreditLineRequests';

export interface ICreditLineTabConfig {
  value: string;
  label: string;
  Component: React.ComponentType;
}

export const CREDIT_LINE_TABS: ICreditLineTabConfig[] = [
  {
    value: 'requests',
    label: 'Línea de crédito',
    Component: CreditLineRequests,
  },
];

export const CREDIT_LINE_TAB_ITEMS = CREDIT_LINE_TABS.map(
  ({ value, label }) => ({
    value,
    label,
  }),
);

export const CREDIT_LINE_DEFAULT_TAB = CREDIT_LINE_TABS[0].value;

export const getTabComponent = (
  value: string,
): React.ComponentType | undefined =>
  CREDIT_LINE_TABS.find((tab) => tab.value === value)?.Component;
